import React from 'react';
import { Link, FileText, Globe, CheckCircle } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    title: 'Paste your YouTube link',
    description: 'Simply copy and paste the URL of the YouTube video you want to transcribe.',
    icon: Link
  }, {
    title: 'Choose your output format',
    description: 'Select whether you want a blog post, transcript, or dubbed video with subtitles.',
    icon: FileText
  }, {
    title: 'Select target languages',
    description: 'Choose the languages you want for your dubbing or blog translation.',
    icon: Globe
  }, {
    title: 'Get your content',
    description: 'Receive your professionally formatted content ready to publish.',
    icon: CheckCircle
  }];
  return <div id="how-it-works" className="bg-gray-50 py-12" data-id="element-150">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        <div className="lg:text-center" data-id="element-152">
          <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase" data-id="element-153">
            How It Works
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl" data-id="element-154">
            Simple process, powerful results
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto" data-id="element-155">
            Our streamlined workflow makes it easy to transform your video
            content in just a few clicks.
          </p>
        </div>
        <div className="mt-10" data-id="element-156">
          <div className="relative" data-id="element-157">
            {/* Connection line */}
            <div className="hidden md:block absolute top-12 left-1/2 w-0.5 h-full -ml-px bg-indigo-200" aria-hidden="true" data-id="element-158"></div>
            <div className="space-y-16" data-id="element-159">
              {steps.map((step, stepIdx) => <div key={step.title} className="relative" data-id="element-160">
                  <div className="flex items-center md:flex-col lg:flex-row" data-id="element-161">
                    <div className="flex-shrink-0 h-12 w-12 rounded-full bg-indigo-500 flex items-center justify-center text-white relative z-10" data-id="element-162">
                      <step.icon className="h-6 w-6" aria-hidden="true" data-id="element-163" />
                    </div>
                    <div className="ml-4 md:ml-0 md:mt-4 lg:mt-0 lg:ml-4" data-id="element-164">
                      <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-165">
                        Step {stepIdx + 1}: {step.title}
                      </h3>
                      <p className="mt-2 text-base text-gray-500" data-id="element-166">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
        <div className="mt-16 flex justify-center" data-id="element-167">
          <div className="max-w-xl rounded-lg bg-indigo-50 p-6 border border-indigo-100" data-id="element-168">
            <h3 className="text-lg font-medium text-indigo-800" data-id="element-169">
              Ready to see it in action?
            </h3>
            <p className="mt-2 text-indigo-600" data-id="element-170">
              Try our demo with a sample YouTube video to see the quality of our
              transcription and blog conversion.
            </p>
            <div className="mt-4" data-id="element-171">
              <button type="button" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-172">
                Try the demo
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}